// extracted by mini-css-extract-plugin
export default {"wrapper":"NegociacoesSalvasFilters_wrapper__xaO94","line":"NegociacoesSalvasFilters_line__Xp5xr"};